const ROUTES = {
  // Main
  HOMEPAGE: "/",
  DENIED: "denied",
  // Carrier Directory
  CARRIER_DIRECTORY_ADD: "carrier-directory/add",
  CARRIER_DIRECTORY_LIST: "carrier-directory/list",
  CARRIER_DIRECTORY_EDIT: "carrier-directory/edit",
  // Index Files
  INDEX_FILE_ADD: "index-file/add",
  INDEX_FILE_LIST: "index-file/list",
  INDEX_FILE_EDIT: "index-file/edit",
  // Data Orders
  DATA_ORDER_ADD: "data-order/add",
  DATA_ORDER_LIST: "data-order/list",
  DATA_ORDER_EDIT: "data-order/edit",
  DATA_ORDER_DETAILS: "data-order/details",
  DATA_ORDER_DETAILS_PRE_PROCESS: "data-order/details-pre-process",
  // Projects
  PROJECT_ADD: "project/add",
  PROJECT_EDIT: "project/edit",
  PROJECT_DETAILS: "project/details",
  // MRF
  MRF_LIST: "mrfs/list",
  // Search Index
  SEARCH_INDEX: "search-index/",
  SEARCH_INDEX_SUMMARY: "search-index/summary",
  // Users
  USER_ADD: "user/add",
  USER_ADD_HFMA: "user/add-hfma",
  USER_LIST: "user/list",
  USER_EDIT: "user/edit",
  // Organizations
  ORG_ADD: "organization/add",
  ORG_LIST: "organization/list",
  ORG_EDIT: "organization/edit",
  // Hospital Directory
  HOSPITAL_DIRECTORY_ADD: "hospital-directory/add",
  HOSPITAL_DIRECTORY_LIST: "hospital-directory/list",
  HOSPITAL_DIRECTORY_EDIT: "hospital-directory/edit",
}

export default ROUTES
